import React from 'react';
import Helmet from 'react-helmet';
import {notIndex, canonicalize} from "../util/helperFunctions";
/* eslint-env browser */
/* eslint-disable react/prop-types */

// this should be tested and built for story and events as well

const canonicalUrl = (route) => {
  const canonical = canonicalize(route)
  if (canonical) {
    return (<link rel="canonical" href={`https://venturerichmond.com${canonical}`} />
    )
  } else {
    return (<link rel="canonical"
          href={`https://venturerichmond.com${
              /^\//.test(route) && route.length > 1 ? route : ''
          }${/^\//.test(route) && route.endsWith('/') ? '' : '/'}`.toLowerCase()}
      />)
  }
}


const Meta = ({ page }) =>
    (
        <Helmet>
            <title>{page.metaTitle}</title>
            {typeof window !== 'undefined' && (
                <meta property="og:url" content={window.location.href} />
            )}
            <meta name="name" itemProp="name" content={page.slug} />
            {/* Deindex pages */}
            {notIndex(page.route) && (
                <meta name="robots" content="noindex" />
            )}
            {/* Google / Search Engine Tags */}
            <meta
                name="description"
                itemProp="description"
                content={page.metaDescription}
            />
            <meta name="keywords" itemProp="keywords" content={page.metaKeywords} />
            <meta name="google-site-verification" content="75cdbf4610e95d39" />
            <meta
                name="google-site-verification"
                content="ksA9BT7VZx7I_7M6Zq6XxhdNOnSaP048BdwW0-WqdrE"
            />
            {canonicalUrl(page.route)}
            {page.abstractPhoto && (
              <meta
                name="image"
                itemProp="image"
                content={page.abstractPhoto.url}
              />
            )}
            {/* Facebook Meta Tags */}
            <meta property="og:site_name" content="Venture Richmond" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content={page.title} />
            <meta property="og:description" content={page.abstract} />
            <meta property="og:image:type" content="image" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            {page.abstractPhoto && (
                <meta property="og:image" content={page.abstractPhoto.url} />
            )}
            {/* Twitter Meta Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={page.title} />
            <meta name="twitter:description" content={page.abstract} />
            {page.abstractPhoto && (
                <meta name="twitter:image" content={page.abstractPhoto.url} />
            )}
        </Helmet>
    );

export default Meta;



// WEBPACK FOOTER //
// ./src/components/Meta.js